import { Dispatch, SetStateAction } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";
import { toMoney } from "shared/utils";
import { Stat } from "views/applications-id-report/components/Stat";
import { mapIncomeSourceStatus } from "views/applications-id-report/slices/CombinedIncomeReportSlice/helpers";
import { EditIncomeModalData } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";
import {
  getIncomeActualNetAndGrossDollars,
  getMonthlyAmount
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";

export const IncomeSliceHeader = ({
  income,
  currentItem,
  setShowEditIncomeModal
}: {
  income: CombinedIncome;
  currentItem?: VerifiedItem | VerifiedItem[];
  setShowEditIncomeModal: Dispatch<SetStateAction<false | EditIncomeModalData>>;
}) => {
  const { status } = mapIncomeSourceStatus(income);
  const isRejected = status === "Rejected";
  const { actualVerifiedNetMonthlyDollars, actualVerifiedGrossMonthlyDollars } =
    getIncomeActualNetAndGrossDollars(income, currentItem);

  return (
    <div className="flex items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat
          title="Verified gross monthly"
          value={
            isRejected && !actualVerifiedGrossMonthlyDollars
              ? "-"
              : toMoney(actualVerifiedGrossMonthlyDollars)
          }
        />
        <Stat
          title="Verified net monthly"
          value={
            isRejected && !actualVerifiedNetMonthlyDollars
              ? "-"
              : toMoney(actualVerifiedNetMonthlyDollars)
          }
        />
        <Stat
          title="Self-reported gross monthly"
          value={toMoney(
            getMonthlyAmount(income.amount_cents, income.pay_period) / 100
          )}
        />
      </div>

      <Button
        variant={ButtonVariant.TEXT}
        className="shrink-0"
        size={ButtonSize.SM}
        onClick={() => {
          setShowEditIncomeModal({
            grossMonthlyIncomeDollars: actualVerifiedGrossMonthlyDollars,
            netMonthlyIncomeDollars: actualVerifiedNetMonthlyDollars,
            hasNetMonthlyIncome: income.type !== "offer_letter",
            incomeId: income.id,
            isTotal: false
          });
        }}
      >
        Edit income source
      </Button>
    </div>
  );
};
